import styled from '@emotion/styled';

const PickerWrapper = styled('div')({
  position: 'relative',
});

export default PickerWrapper;
